import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchSystemValid = createAsyncThunk('systems/fetchValid', async (type_id, thunkAPI) => {
  const result = await fetch(`/api/v2/system-valids?type_id=${type_id}`)
    .then(res => res.json());

  return result;
})